import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import WalletTag from "./WalletTag";
import TextChangeBalance from "../common/TextChangeBalance";
import TextTotalBalance from "../common/TextTotalBalance";

const headers = ["PAYMENT ID", "TYPE", "AMOUNT", "BALANCE", "DATE"];

export default function TableWallet({ data = [], ...restProps }) {
  return (
    <Box
      {...restProps}
      sx={{ backgroundColor: "#191922", borderRadius: "8px" }}
    >
      <TableContainer>
        <Table sx={{ minWidth: 350, padding: 8 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {headers.map((header, index) => {
                return (
                  <TableCell
                    key={index}
                    align="left"
                    sx={{ color: "white", borderBottomColor: "#383841" }}
                  >
                    {header}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:last-child td, &:last-child th": {
                    border: 0,
                  },
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ color: "white", borderBottomColor: "#383841" }}
                >
                  {row.id}
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ color: "white", borderBottomColor: "#383841" }}
                >
                  {row.type === "deposit" ? (
                    <WalletTag size="small" type="deposit" />
                  ) : (
                    <WalletTag size="small" type="withdraw" />
                  )}
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ color: "white", borderBottomColor: "#383841" }}
                >
                  <TextChangeBalance
                    textAlign="left"
                    type={row.type === "deposit" ? "add" : "divide"}
                    amount={row.amount}
                  />
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ color: "white", borderBottomColor: "#383841" }}
                >
                  <TextTotalBalance large={true} amount={row.balance} />
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ color: "white", borderBottomColor: "#383841" }}
                >
                  {row.date}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
